(function () {
  if (!window.B2B?.enabled) return;
  const excludedTags = ['client_b2b', 'espresso_bar_iasi'];
  const tags = window.B2B?.customerTags || [];
  if (excludedTags.some(t => tags.includes(t))) return;

  let updating = false;
  let lastNote = null;
  let debounceTimer = null; // ← NOU

  function getKg(value) {
    if (!value) return 0;
    value = value.toLowerCase().replace(',', '.');
    const gramsMatch = value.match(/(\d+)\s*(g|gr)/);
    if (gramsMatch) {
      const grams = parseInt(gramsMatch[1]);
      if (grams === 1000 || grams === 3000) return grams / 1000;
      return 0;
    }
    const kgMatch = value.match(/(\d+(\.\d+)?)\s*kg/);
    if (kgMatch) {
      const kg = parseFloat(kgMatch[1]);
      if (kg === 1 || kg === 3) return kg;
      return 0;
    }
    return 0;
  }

  function getVariant(item) {
    let variant = '';
    if (item.properties) {
      for (let key in item.properties) {
        if (key.toLowerCase().includes('gramaj')) {
          variant = item.properties[key];
        }
      }
    }
    if (!variant && item.variant_title && item.variant_title !== 'Default Title') {
      variant = item.variant_title;
    }
    return variant;
  }

  function calculate(cart) {
    // ← NOU: grupează produsele identice înainte de calcul
    const grouped = {};

    cart.items.forEach(item => {
      const variant = getVariant(item);
      const kgPerItem = getKg(variant);
      if (kgPerItem === 0) return;

      const key = `${item.product_title}__${variant}`;
      if (!grouped[key]) {
        grouped[key] = { title: item.product_title, variant, kgPerItem, quantity: 0 };
      }
      grouped[key].quantity += item.quantity;
    });

    let totalBonus = 0;
    let breakdown = [];

    Object.values(grouped).forEach(({ title, variant, kgPerItem, quantity }) => {
      const lineKg = kgPerItem * quantity;
      const lineBonus = Math.floor(lineKg / 10) * 2;
      totalBonus += lineBonus;

      if (lineBonus > 0) {
        breakdown.push({ title, variant, bonusKg: lineBonus });
      }
    });

    // Bonusul se dă per cafea (10kg din același produs → +2kg), deci totalul
    // e suma liniilor, nu kg-ul total din coș
    return { totalBonus, breakdown };
  }

  function buildNote(data) {
    if (data.totalBonus <= 0) return '';
    const lines = data.breakdown.map(item => {
      const variantText = item.variant ? ` - ${item.variant}` : '';
      return `+${item.bonusKg}kg → ${item.title}${variantText}`;
    });
    return `Bonus B2B:\n${lines.join('\n')}\nTotal bonus: +${data.totalBonus}kg`;
  }

  // Pe lângă notă scriem și un atribut de cart: apare în admin la
  // "Additional details", iese în exportul CSV și e citit de Shopify Flow
  // pentru auto-tag-ul comenzilor cu bonus
  async function syncNote(force) {
    const res = await fetch('/cart.js');
    const cart = await res.json();

    const hasB2BTag =
      (window.customerTags && window.customerTags.includes('client_b2b')) ||
      (document.body.dataset.customerTags || '').includes('client_b2b');

    let note = '';
    let bonusKg = 0;
    if (hasB2BTag) {
      note = 'Acest client nu are bonus';
    } else {
      const data = calculate(cart);
      note = buildNote(data);
      bonusKg = data.totalBonus;
    }

    if (!force && note === lastNote) return; // ← skip dacă nota nu s-a schimbat

    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        note,
        attributes: { 'Bonus B2B (kg)': bonusKg > 0 ? String(bonusKg) : '' }
      })
    });

    lastNote = note;
  }

  async function updateNote() {
    if (updating) return;
    updating = true; // ← imediat, înainte de orice await

    try {
      await syncNote(false);
    } finally {
      updating = false; // ← mereu resetat, chiar și la eroare
    }
  }

  // Expus pentru b2b-checkout-sync.js: scriere directă, fără debounce
  // și fără skip, chiar înainte de plecarea spre checkout
  window.B2BUtils = window.B2BUtils || {};
  window.B2BUtils.writeBonusNow = () => syncNote(true);

  function run() {
    clearTimeout(debounceTimer); // ← NOU: anulează apelul anterior
    debounceTimer = setTimeout(updateNote, 300);
  }

  run();

  document.addEventListener('input', run);
  document.addEventListener('click', run);
  document.addEventListener('cart:updated', run);
})();